
import { Link } from "react-router-dom"

export default function Form1() {
	return (
		<>

			<div className="widget-form-register">
				<div className="row">
					<div className="col-md-6 pd-form image-register">
						<img src="images/slides/m11.jpg" alt="image" />
					</div>
					<div className="col-md-6 pd-form">
						<div className="widget-register background-green">
							<div className="heading-register">
								<h2 className="title-register">Hisoratra anarana </h2>
							</div>
							<div className="list-contact">
								<div className="contact">
									<span> Telephone: </span>
									<div className="address">034 41 099 09 / 032 02 006 16</div>
								</div>
								<div className="contact">
									<span> Mailaka: </span>
									<div className="address">hazakazaka@fandriana-milay.org</div>
								</div>
							</div>
							<ul className="social-media">
								<li>
									<Link to="/twitter.com"><i className="icon-facebook" /></Link>
								</li>

							</ul>
							<div className="form-register">
								<form id="registerform" className="register-form" noValidate>
									<fieldset className="name-container">
										<input type="text" id="author" placeholder="Anarana*" className="tb-my-input" name="author" tabIndex={1} size={32} aria-required="true" />
									</fieldset>
									<fieldset className="email-container">
										<input type="text" id="email" placeholder="Ny mailaka*" className="tb-my-input" name="email" tabIndex={2} size={32} aria-required="true" />
									</fieldset>
									<fieldset className="telephone-container">
										<input type="text" id="telephone" placeholder="Telephone*" className="tb-my-input" name="telephone" tabIndex={1} size={32} aria-required="true" />
									</fieldset>
									<fieldset className="sex-container">
										<select name="sex" id="sexs" className="tb-my-input" aria-required="true">
											<option value>Lahy</option>
											<option value="female">Vehivavy</option>
										</select>
									</fieldset>
									<fieldset className="sex-container">
										<select name="sex" id="sexs" className="tb-my-input" aria-required="true">
											<option value>Sokajy</option>
											<option value={5}>5km</option>
											<option value={15}>15km</option>
										</select>
									</fieldset>
									<p className="form-submit">
										<input name="submit" type="submit" id="comment-reply" className="submit-register" defaultValue="Join now" />
									</p>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
